<div class="abc-modal-container tw-flex tw-flex-col tw-w-full">

  <!-- Header -->
  <div
    class="
      modal-header
      tw-flex
      tw-items-center
      tw-justify-between
      tw-bg-[#1B478A]
      tw-text-[#FFFFFF]
      tw-rounded-t-[12px]
      tw-px-[16px]
      tw-py-[14px]
    "
  >
    <p class="tw-text-[18px] tw-font-bold tw-uppercase tw-mb-0">
      {{ 'ui.wager.place.wager' | translate: 'Place Wager' }}
    </p>
    <button
      type="button"
      mat-icon-button
      (click)="close()"
      attr.aria-label="{{ 'generic.close' | translate: 'Close' }}"
      class="!tw-text-white"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Body -->
  <div class="modal-body tw-bg-white tw-px-[20px] tw-py-[16px]">

    <!-- Race / pool / runners summary -->
    <div
      class="race-pool tw-border-b tw-border-[#2F80EC] tw-pb-[8px] tw-mb-[12px]"
    >
      <span
        class="tw-block tw-uppercase tw-font-bold tw-text-[18px] tw-text-[#0E2543]"
      >
        {{ eventName }}
      </span>
      <span
        class="tw-uppercase tw-font-bold tw-text-[16px] tw-text-[#0E2543]"
      >
        {{ 'generic.race' | translate: 'Race' }} {{ selectedRace?.RaceId }}
      </span>
    </div>

    <!-- Groups & rows -->
    <div class="current-bets tw-max-h-[330px] tw-overflow-y-auto tw-pr-[2px]">
      @for (parentItem of abcTicket; track parentItem; let i = $index) {
        @if (parentItem?.ABCTicket && parentItem.ABCTicket.Wagers?.length > 0) {
          <div class="abc-group tw-mb-[10px]">
            <div class="abc-type tw-border-b tw-border-[#6C6C6C] tw-pt-[10px] tw-pb-[6px]">
              <span class="tw-font-bold tw-text-[13px] tw-text-[#1B478A] tw-uppercase">
                {{ groupLabels[i] || ('Group ' + (i + 1)) }}
              </span>
            </div>

            @for (childItem of parentItem.ABCTicket.Wagers; track childItem; let z = $index) {
              <div
                class="
                  bet-row
                  tw-flex
                  tw-flex-wrap
                  tw-items-center
                  tw-justify-between
                  tw-gap-x-[10px]
                  tw-gap-y-[2px]
                  tw-border-b
                  tw-border-[#B4B3B3]
                  tw-py-[8px]
                "
              >

                <span
                  class="amount1 tw-font-bold tw-text-[13px] tw-text-[#0E2543] tw-min-w-[50px]"
                >
                  ${{ childItem.BaseAmount | number:'1.2-2' }}
                </span>

                <span
                  class="
                    amount-percent tw-font-semibold tw-text-[13px] tw-text-[#1B478A]
                    tw-flex-1 tw-text-center
                  "
                >
                  {{ childItem.getWagerString()[2] }}
                </span>

                <span
                  class="amount2 tw-font-bold tw-text-[13px] tw-text-[#036E23] tw-min-w-[60px] tw-text-right"
                >
                  ${{ (childItem.BaseAmount * childItem.Bets) | number:'1.2-2' }}
                </span>

                @if (
                  !parentItem?.submitted &&
                  !parentItem?.saved &&
                  !parentItem?.removed
                ) {
                  <div class="tw-flex tw-items-center tw-gap-[6px]">
                    <button
                      type="button"
                      mat-flat-button
                      color="primary"
                      class="!tw-min-w-[78px] !tw-h-[28px] !tw-leading-[28px] submit-bet"
                      (click)="submitBet(i)"
                    >
                      {{ 'generic.submit' | translate: 'SUBMIT' }}
                    </button>
                    <button
                      type="button"
                      mat-flat-button
                      color="accent"
                      class="!tw-min-w-[68px] !tw-h-[28px] !tw-leading-[28px] save-bet"
                      (click)="saveBet(i)"
                    >
                      {{ 'generic.save' | translate: 'SAVE' }}
                    </button>
                    <button
                      type="button"
                      mat-icon-button
                      color="warn"
                      (click)="removeBet(i)"
                      attr.aria-label="{{ 'ui.wager.remove.wager' | translate: 'Remove wager' }}"
                    >
                      <mat-icon>delete_outline</mat-icon>
                    </button>
                  </div>
                } @else {
                  <span
                    class="
                      tw-uppercase tw-font-bold tw-text-[13px] tw-text-[#036E23]
                    "
                  >
                    @if (parentItem?.submitted) { {{ 'ui.wager.submitted' | translate: 'Submitted' }} }
                    @else if (parentItem?.saved) { {{ 'ui.wager.saved' | translate: 'Saved' }} }
                    @else if (parentItem?.removed) { {{ 'ui.wager.removed' | translate: 'Removed' }} }
                  </span>
                }

                @if (childItem?.Error) {
                  <div
                    [id]="'error-index-' + i"
                    class="no-valid-wager tw-w-full tw-text-[13px] tw-text-[#D32F2F] tw-pl-[2px]"
                  >
                    {{ childItem.Error }}
                  </div>
                }
              </div>
            }
          </div>
        }
      }
    </div>

  </div>

  <!-- Actions -->
  <div
    class="
      modal-actions
      tw-flex
      tw-justify-between
      tw-gap-[10px]
      tw-bg-white
      tw-rounded-b-[12px]
      tw-px-[20px]
      tw-pb-[18px]
      tw-pt-[6px]
    "
  >
    <button
      type="button"
      mat-flat-button
      color="primary"
      class="!tw-flex-1 !tw-rounded-full submit-btn"
      (click)="submitAll()"
    >
      {{ 'ui.wager.submit.all' | translate: 'SUBMIT ALL' }}
    </button>
    <button
      type="button"
      mat-flat-button
      color="accent"
      class="!tw-flex-1 !tw-rounded-full save-btn"
      (click)="saveAll()"
    >
      {{ 'ui.wager.save.all' | translate: 'SAVE ALL' }}
    </button>
    <button
      type="button"
      mat-stroked-button
      color="warn"
      class="!tw-flex-1 !tw-rounded-full close-btn"
      (click)="close()"
    >
      {{ 'ui.wager.close.all' | translate: 'CLOSE ALL' }}
    </button>
  </div>

</div>
